import { Navigate } from "react-router-dom";

const RoleBasedRoute = ({ children, allowedRoles }) => {
    const currentRole = parseInt(localStorage.getItem("currentRole"));

    // If no role is found, redirect to login
    if (!currentRole) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(currentRole)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default RoleBasedRoute;